const state = {
  sidebarStatus: sessionStorage.getItem('sidebarStatus')
    ? sessionStorage.getItem('sidebarStatus')
    : true,
  screen: 'large',
  showFilter: false,
  tabActivekey: 'Chat',
  /**
   * @param type public | private
   * @param receiver public 时为空 private时为 patient 或 doctor
   */
  chatToControler: { type: 'public', receiver: '' }
}

const mutations = {
  // 工作台打开的Tab
  SET_TABS_ACTIVE: (state, data) => {
    state.tabActivekey = data
  },
  // 群聊或私聊、私聊对象
  SET_CHATRECEIVER_TYPE: (state, data) => {
    state.chatToControler = data
  },
  // 字段设置熟悉
  CHANGE_SETTING: (state, { key, value }) => {
    if (key in state) {
      state[key] = value
    }
  },
  // 设置侧边栏
  TOGGLE_SIDEBAR: (state, isOpen) => {
    state.sidebarStatus = isOpen
    sessionStorage.setItem('sidebarStatus', isOpen)
  },
  // 设置屏幕
  TOGGLE_SCREEN: (state, screen) => {
    state.screen = screen
  },
  SET_FILTER: (state, show = false) => {
    state.showFilter = show
  }
}
const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  toggleScreen({ commit }, screen) {
    commit('TOGGLE_SCREEN', screen)
    commit('TOGGLE_SIDEBAR', screen === 'large')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
